import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sss-leading-eu-visibility',
  templateUrl: './leading-eu-visibility.component.html',
  styleUrls: ['./leading-eu-visibility.component.scss']
})
export class LeadingEUVisibilityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
